package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.db_service.register
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.Admin

@Composable
fun EditAdminDialog(
    admin: Admin,
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var isLoading by remember { mutableStateOf(false) }

    var fullName by remember { mutableStateOf(admin.fullName) }
    var email by remember { mutableStateOf(admin.email) }

    var errorMessage by remember { mutableStateOf("") }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }

            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {


            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {
                Text("Update Administrator")
            }


            P(
                attrs = DialogSubtitleStyle.toAttrs()
            ) {
                Text("Update an  admin account with full access.")
            }

            // Full Name

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {

                    Text("Full Name")

                }


                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder("Loveness Leonard")

                            value(fullName)

                            onInput {
                                fullName = it.value
                            }


                            if(isLoading){
                                disabled()
                            }

                        }
                )

            }




            // Email

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ){

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ){
                    Text("Email")
                }


                Input(
                    type = InputType.Email,
                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {
                                 disabled()
                            placeholder("sample@example.com")

                            value(email)

                            onInput {
                                email = it.value
                            }


                            if(isLoading){
                                disabled()
                            }

                        }
                )

            }


            if (errorMessage.isNotEmpty()) {

                P(
                    attrs = Modifier
                        .color(Color.rgb(220, 53, 69))
                        .fontSize(14.px)
                        .margin(0.px, 0.px, 16.px)
                        .toAttrs()
                ) {

                    Text(errorMessage)

                }

            }



            Row(
                modifier = DialogActionsRowStyle.toModifier(),

                horizontalArrangement = Arrangement.spacedBy(12.px)
            ){



                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(CancelButtonStyle.toModifier()),


                    onClick = {

                        onDismiss()

                    }

                ){

                    Text("Cancel")

                }





                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(SaveButtonStyle.toModifier()),


                    onClick = {

                        scope.launch {

                            try {

                                errorMessage = ""


                                // Validate fields
                                if (fullName.isBlank()) {

                                    errorMessage = "Full name is required"
                                    return@launch

                                }

                                isLoading = true


                                val user = FirebaseService.auth.currentUser


                                if (user == null) {

                                    errorMessage = "Firebase user was not found"
                                    return@launch

                                }


                                console.log("User UID: ${user.uid}")


                                // Save profile data to Firestore
                                val usersCollection = collection(
                                    FirebaseService.db,
                                    "users"
                                )


                                val admin = Admin(
                                    uid = user.uid,
                                    fullName = fullName,
                                    email = email
                                )


// Document ID = email
                                val adminDocument = doc(
                                    usersCollection,
                                    email.lowercase()
                                )


                                setDoc(
                                    adminDocument,
                                    admin.toFirebaseData()
                                ).await()

                                console.log("Admin saved successfully")

                                onSuccess()   // refresh parent list

                                isLoading = false

                                // Close dialog
                                onDismiss()


                            } catch (e: Throwable) {


                                console.error(
                                    "Registration error: ${e.message}"
                                )


                                errorMessage =
                                    e.message ?: "Something went wrong"


                            } finally {


                                isLoading = false


                            }

                        }

                    }

                ){

                    Text(
                        if(isLoading)
                            "Saving..."
                        else
                            "Save"
                    )

                }


            }


        }

    }

}